<template>
  <div class="login-wrap">
      <div class="login_bg">
      </div>
      <div class="login_center">
        <div class="left_img">
        </div>
        <div class="right_content">
          <div class="ms-title">
            <img class="icon" src="../../assets/login/lehuo_icon.png"/>
            <span class="logotitle">智慧养老管理平台</span>
          </div>
          <el-form 
              :model="ruleForm2"
              :rules="rules2"
              ref="ruleForm2"
              label-position="left"
              label-width="0px"
              class="demo-ruleForm login-container ms-content">
              <!-- 登录页面账号 -->
              <el-form-item prop="account">
                <el-input
                  prefix-icon="el-icon-s-custom"
                  v-model="ruleForm2.account"
                  type="text" 
                  id="lhAccount" 
                  name="lhAccount" 
                  autocomplete="lhAccount"
                  placeholder="用户名"
                ></el-input>
              </el-form-item>
              <!-- 登录页面密码 -->
              <el-form-item prop="checkPass" style="margin-top:20px">
                <el-input
                  prefix-icon="el-icon-lock"
                  :type="passwordEye"
                  v-model="ruleForm2.checkPass"
                  placeholder="密码"
                  show-password
                ></el-input>
              </el-form-item>
              <!-- 登录页面验证码 -->
              <el-form-item class="code" prop="code">
                <el-col :span="4"
                  ><el-input
                    class="yancode"
                    placeholder="验证码"
                    v-model="ruleForm2.code"
                  ></el-input
                ></el-col>
                <el-col :span="8" :offset="5">
                  <span class="code">
                    <s-identify :identifyCode="identifyCode"></s-identify> </span
                ></el-col>
                <el-col
                  :span="7"
                  style="height: 40px; line-height: 40px; font-size: 12px"
                  ><span>看不清？</span
                  ><span class="refreshCode" @click="refreshCode">换一张</span></el-col
                >
              </el-form-item>
              <el-form-item class="login_btn">
                <el-button
                  type="primary"
                  style="width: 100%; background: #0cb1ec; font-size: 16px"
                  @click.native.prevent="handleSubmit"
                  @keyup.enter.native.prevent="enterLogin(ruleForm2)"
                  :loading="logining"
                  >登录</el-button
                >
              </el-form-item>
          </el-form>
        </div>
      </div>
  </div>
</template>
<script>
import SIdentify from "../../components/child/identify"; //验证码组件
export default {
  data() {
    var validateCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码")); //
      } else if (value == "0000") {
        callback();
      } else if (value !== this.identifyCode) {
        callback(new Error("请输入正确的验证码"));
      } else {
        callback();
      }
    };
    return {
      check: "", //记住密码选取的状态
      PasswordEyeDiv: false, //密码 眼睛图片的状态  默认隐藏
      passwordEye: "password", //密码默认为不可见
      eyeShowPassword: true, //密码 显示隐藏密码的眼睛图片的状态  默认为eye_open
      identifyCodes: "1234567890", //初始值
      identifyCode: "", //验证码初始值
      groupCode:'', //sessionStorage存的
      login: {
        backgroundRepeat: "no-repeat",
        backgroundSize: "110% 100%",
        width: "100%",
        height: "100%",
      },
      logining: false,
      ruleForm2: {
        //登录的参数
        account: "",
        checkPass: "",
        code: "",
        //修改密码的参数
        accountEdit: "",
        oldPassEdit: "",
        newPassEdit: "",
      },
      rules2: {
        //登录正则
        account: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        checkPass: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        code: [{ validator: validateCode, trigger: "blur" }],
      },
      checked: true,
      readonlyAccount: true,
      readonlycheckPass: true,
    };
  },
  methods: {
    //登录
    handleSubmit(ev) {
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          this.logining = true;
          var loginParams = {
            username: this.ruleForm2.account,
            password: this.ruleForm2.checkPass,
          };
          this.$postLogin("uac/auth/form", loginParams)
            .then((response) => {
              window.sessionStorage.setItem(
                "Authorization","Bearer " + response.access_token);
              window.sessionStorage.setItem("username", loginParams.username);
              window.sessionStorage.setItem("password", loginParams.password);
              localStorage.setItem('username', loginParams.username);
              localStorage.setItem('password', loginParams.password);
              sessionStorage.setItem(
                "user",
                JSON.stringify(this.ruleForm2.account)
              );
              this.getUserData();
              // this.$router.push('/');
              // this.$message({
              //   type: "success",
              //   message: "登录成功",
              // });
            })
            .catch((error) => {
              this.logining = false;
              if (error.code == 500) {
                this.$message({
                  type: "error",
                  message: error.message,
                });
              }
              this.identifyCode = "";
              this.makeCode(this.identifyCodes, 4);
            });
        } else {
          return false;
        }
      });
    },
    //enter回车登录
    enterLogin(ruleForm2) {
      this.handleSubmit();
    },
    //点击账号框聚焦  密码眼睛图片隐藏
    focusAccount() {
      this.PasswordEyeDiv = false;
      this.readonlyAccount = false;
    },
    //点击密码框聚焦  密码眼睛图片显示
    focusShowPasswordEye() {
      this.PasswordEyeDiv = true;
      this.readonlycheckPass = false;
    },

    //点击验证码聚焦  密码眼睛图片隐藏
    focusCode() {
      this.PasswordEyeDiv = false;
    },

    //点击密码可见眼睛图片  使密码显示和隐藏
    changePassword(value) {
      if (value == "show") {
        this.passwordEye = "text";
        this.eyeShowPassword = false;
      } else {
        this.passwordEye = "password";
        this.eyeShowPassword = true;
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },
    getUserData() {
      this.$postForm("uac/user/getInformation", {}).then((response) => {
            this.logining = false;
            sessionStorage.setItem("groupId", response.result.groupId); 
            sessionStorage.setItem("groupType", response.result.groupType); 
            sessionStorage.setItem("roleCode", response.result.role); 
            if(response.result.role == "street" || response.result.role == "community" ){
              this.$message({
                type: "error",
                message: "暂无权限登录",
              });
              return;
            }
            if(response.result.groupType == "9"){
              this.$router.push('/bigView');
              this.$message({
                type: "success",
                message: "登录成功",
              });
              return;
            }
            this.$router.push('/');
            this.$message({
              type: "success",
              message: "登录成功",
            });
        }).catch(err=>{
          this.$router.push('/');
            this.$message({
              type: "success",
              message: "登录成功",
            });
        });
    },
  },
  computed: {
    checkPassNew() {
      return this.ruleForm2.checkPass;
    },
  },
  mounted() {
    // this.getCookie();
    const storedUsername = localStorage.getItem('username');
    const storedPassword = localStorage.getItem('password');
    if (storedUsername && storedPassword) {
      this.ruleForm2.account = storedUsername;
      this.ruleForm2.checkPass = storedPassword;
    }
    this.groupCode = sessionStorage.getItem('groupCode','');
    sessionStorage.removeItem("currentIndex");
    this.identifyCode = ""; //清空
    this.makeCode(this.identifyCodes, 4); //获取新的验证码
    // 在登录获取用户分辨率高度,放到sessionStorage中存起来,为以后的页面中的表格height赋值
    sessionStorage.setItem("screenHeight", Number(window.screen.height));
  },
  created() {
    var _self = this;
    document.onkeydown = function (e) {
      if (window.event == undefined) {
        var key = e.keyCode;
      } else {
        var key = window.event.keyCode;
      }
      if (key == 13) {
        _self.enterLogin("ruleForm2");
      }
    };
  },
  components: { SIdentify }, //注册组件
};
</script>

<style lang="scss" scoped>
.login-container {
  background-clip: padding-box;
  flex: 1 1 auto;
  max-width: 400px;
  height: 100%;
  background: #fff;
  background-color: transparent;
}
.refreshCode:hover {
  color: rgb(231, 76, 15);
  cursor: pointer;
  transition: 0.3s;
}
::v-deep .code {
  height: 28px !important;
  line-height: 25px;
  margin-top: 20px;
  vertical-align: middle;
}
.login-wrap {
  width: 100%;
  min-height: 100%;
  height: 100%;
}
.login_bg{
  position: relative;
  overflow: hidden;
  z-index: 1;
  width: 100%;
  height: 100%;
  filter: blur(1px);
  background-image: url(../../assets/login/login_bg_1.png);
  background-size: cover;
}
.ms-title {
    width: 100%;
    text-align: center;
    font-size: 28px;
    margin: 0;
    margin-bottom: 20px;
    padding-top: 50px;
    color: #000;
  .icon{
    height: 36px;
    vertical-align: middle;
    width: 36px;
    margin-right: 8px;
  }
  .logotitle{
    vertical-align: middle;
    font-family: system-ui;
    color: #212121;
  }
}
.login_center{
  position: relative;
  left: 25%;
  top: -80%;
  width: 50%;
  height: 60%;
  z-index: 2;
  border-radius: 8px;
  //caret-color: rgba(0, 0, 0, 0); 闪烁的文本黑线 
  box-shadow: 0 0 20px 2px #79afdc; 
  display: flex;
  background: white;
  overflow: hidden;
  .left_img{
    flex: 5;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    filter: blur(1px);
    background-image: url(../../assets/login/login_bg_2.png);
    background-size: cover;
  }
  .right_content{
    flex: 6;
    width: 100%;
    height: 100%;
    border-top-right-radius: 8px;
    background: white;
    border-bottom-right-radius: 8px;
  }
}
.ms-content {
    padding-top: 50px;
    width: 300px;
    text-align: center;
    margin: 0 auto;
}
.login_btn{
  width: 100%;
  margin-top: 50px;
  margin-bottom: 5px;
}
.yancode{
  width: 100px;
}
@media (max-width: 1220px){ 
  .ms-content {
    padding-top: 10px;
    width: 250px;
    text-align: center;
    margin: 0 auto;
  }
  .login_btn{
    width: 100%;
    margin-top: 10px;
    margin-bottom: 5px;
  }
  .yancode{
    width: 80px;
  }
  .refreshCode{
    display: none;
  }
}
.login-container ::v-deep .el-input__inner::placeholder {
  color: #8a8b8d;
}
.login-container ::v-deep .el-input__inner {
  border: 1px solid #8a8b8d;
}
.login-container ::v-deep .el-input__prefix{
  color: #8a8b8d;
}
</style>
